import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import classNames from "classnames/bind";
import axiosClient from "../../services/axiosClient";
import { convertToSeconds, formatDB, formatSecondToHour } from "../../utils";
import styles from "./TimeLine.module.css";
import { StateContext } from "../../layouts/Layout/Layout";
import { Tooltip } from "antd";

const cx = classNames.bind(styles);
const TimeLine = ({
  hour,
  setHour,
  type,
  timeStart,
  list,
  currentPage,
  screen,
  camera,
  index,
  length,
  timeH,
  setTimeH,
  locate,
  setLocate,
}) => {
  const { collapsed, setCollapsed } = useContext(StateContext);
  const resizeTimeout = useRef(null)
  const [time, setTime] = useState([]);
  const ref = useRef();
  const [show, setShow] = useState(true);
  const [data, setData] = useState([]);
  const [width, setWidth] = useState(0);
  const [width2, setWidth2] = useState(0);
  const [listTime, setListTime] = useState([]);
  console.log(width);
  
  const handleClick = (e) => {
    setHour(formatSecondToHour(((3600 * type) / width) * e.nativeEvent.layerX));
    setLocate(e.nativeEvent.layerX);
  };
  const handleMouseMove = (e) => {
    setTimeH(
      formatSecondToHour(((3600 * type) / width) * e.nativeEvent.layerX)
    );
    setLocate(e.nativeEvent.layerX);
  };
  useEffect(() => {
    setTimeH(hour);
  }, [hour]);
  useEffect(() => {
    setTime(
      type === 24
        ? [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22]
        : [0, 2, 4, 6, 8, 10]
    );
    setLocate(convertToSeconds(hour) / ((3600 * type) / width));

    if (
      type === 12 &&
      convertToSeconds(hour) > convertToSeconds(`${type}:00:00`)
    ) {
      setHour("00:00:00");
      setLocate(0);
    }
    // eslint-disable-next-line
  }, [width, type, hour]);
  useEffect(() => {
    const listCodeCamera = list();
    async function getListTimeLine() {
      try {
        const res = await axiosClient.get("/camPlayback/get-list-timeline/", {
          params: {
            list_camera_code: JSON.stringify({
              data: [
                {
                  camera_code: camera.camera_code,
                },
              ],
            }),
            day: formatDB(timeStart),
          },
        });
        setData(res);
      } catch (e) { }
    }
    if (listCodeCamera.data.data.length > 0) {
      getListTimeLine();
    }
  }, [type, timeStart, currentPage, camera.camera_code, width]);

  const onResize = () => {
    if (ref.current) {
      setWidth(ref.current?.clientWidth);
    }
  };
  // useEffect(() => {
  //   const observer = new ResizeObserver(entries => {
  //     for (let entry of entries) {
  //       const { width, height } = entry.contentRect;
  //       console.log(width);
        
  //       setWidth(width);
  //     }
  //   });

  //   if (ref.current) {
  //     observer.observe(ref.current);
  //   }

  //   return () => {
  //     observer.disconnect();
  //   };
  // }, []);
  // useEffect(() => {
  //   let clear;
  //   if (width !== width2) {
  //     setShow(false);
  //     clear = setTimeout(() => {
  //       setShow(true);
  //     }, 100);
  //     setWidth(width2);
  //     setWidth2(ref.current?.clientWidth);
  //   }
  //   return () => clearInterval(clear);
  // }, [collapsed]);
  // useEffect(() => {
  //   if (ref.current && !width2 && width) {
  //     setWidth2(width + (280 - 128));
  //   }
  // }, [width]);
  const handleLeave = (e) => {
    setLocate(convertToSeconds(hour) / ((3600 * type) / width));
    setTimeH(hour);
  };
  React.useEffect(() => {
    let list = [];
    data.forEach((item, index) => {
      list = [...list, ...item.timeline_record];
    });
    setListTime(list);
  }, [currentPage, data, screen, list]);
  function debounce(func){
    var timer;
    return function(event){
      if(timer) clearTimeout(timer);
      timer = setTimeout(func,100,event);
    };
  }
  useEffect(() => {
    const observer = new ResizeObserver(() => {
      if (resizeTimeout.current) clearTimeout(resizeTimeout.current);
      
      // Debounce để tránh xử lý quá nhanh
      resizeTimeout.current = setTimeout(() => {
        onResize();
      }, 50);
    });

    if (ref.current) {
      observer.observe(ref.current);
      onResize(); // Cập nhật ngay khi component mount
    }

    // Lắng nghe resize window để tránh lỗi khi thay đổi nhanh
    const handleResize = () => {
      if (resizeTimeout.current) clearTimeout(resizeTimeout.current);
      resizeTimeout.current = setTimeout(onResize, 50);
    };
    window.addEventListener("resize", handleResize);
    const changeSize = setInterval(() => {
      onResize();
    }, 500);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", handleResize);
      if (resizeTimeout.current) clearTimeout(resizeTimeout.current);
      clearInterval(changeSize)
    };
  }, []);
  return (
    <div className={cx('time_line')}>
      {show && (
        <>
          <Tooltip title={camera.name_cam}><div className={cx("name")}>{camera.name_cam}</div></Tooltip>
          <div className={cx("timeline_container")}>
            <div className={cx("timeline")}>
              <div
                style={{
                  position: "absolute",
                  width: 4,
                  top: index === 0 ? 0 : -10,
                  bottom: 0,
                  left: locate,
                  background: "rgba(0, 64, 255, 1)",
                  zIndex: 5,
                  borderRadius: 2,
                  boxShadow:
                    "0px 4px 8px 0px rgba(0, 0, 0, 0.06), 0px 0px 4px 0px rgba(0, 0, 0, 0.04)",
                  // height: 54,
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: -22,
                  left: locate - 15,
                  zIndex: 5,
                  // height: '50%'
                }}
              >
                {/* <TimeLineIcon /> */}
              </div>

              {index === 0 && (
                <div className={cx("timeL", 'time-split')}>
                  {time.map((item, index) => {
                    let left = (width / type) * item;
                    if (item > 0) {
                      return (
                        <Fragment key={index}>
                          <div
                            style={{
                              position: "absolute",
                              width: 1,
                              top: 0,
                              bottom: 0,
                              left: left,
                              background: "rgba(0, 0, 0, 0.4)",
                              zIndex: 2,
                              color: "rgba(0, 0, 0, 0.4)",
                              fontSize: 12,
                            }}
                          >
                            <span
                              style={{
                                position: "absolute",
                                // left: 8,
                                fontSize: 12,
                                top: 6,
                              }}
                            >{`${item}:00`}</span>
                          </div>
                        </Fragment>
                      );
                    } else {
                      return (
                        <span
                          style={{
                            color: "rgba(0, 0, 0, 0.4)",
                            position: "absolute",
                            left: 8,
                            fontSize: 12,
                            top: 6,
                          }}
                        >{`${item}:00`}</span>
                      );
                    }
                  })}
                </div>
              )}

              <div ref={ref} className={cx("bar")}>
                {listTime?.length > 0 &&
                  listTime.map((item, index) => {
                    let left =
                      (width / (3600 * type)) *
                      convertToSeconds(item?.TIME_START);
                    let right =
                      width -
                      (width / (3600 * type)) *
                      convertToSeconds(
                        item?.TIME_END ? item?.TIME_END : "19:00:00"
                      );
                    if (
                      item?.TIME_END &&
                      convertToSeconds(item?.TIME_END) <
                      convertToSeconds(`${type}:00:00`)
                    ) {
                      return (
                        <div
                          key={index}
                          style={{
                            position: "absolute",
                            right: right,
                            top: 0,
                            bottom: 0,
                            left: left,
                            background: "#1ba3dd",
                          }}
                        ></div>
                      );
                    } else {
                      return <Fragment />;
                    }
                  })}
                <div
                  onMouseLeave={handleLeave}
                  onMouseMove={handleMouseMove}
                  onMouseUp={handleClick}
                  className={cx("click")}
                ></div>
                {(index === screen * currentPage - 1 ||
                  index === length - 1) && (
                    <div
                      className={cx("time")}
                      style={{
                        color: "rgba(0, 64, 255, 1)",
                        position: "absolute",
                        top: "100%",
                        left: locate - 30,
                        zIndex: 10,
                      }}
                    >
                      {timeH}
                    </div>
                  )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TimeLine;
